import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { CardSetTransformationService, DialogService, CoreService, SpinnerService, DataService, VerticalNavigationSettings, FormNavigationService, SaveFormEvent, SaveDataRequest } from 'dspx-core';
import { finalize, Subscription, take } from 'rxjs';
import { API_ENDPOINT_KEYS, API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { APP_DATA_KEYS, FORM_IDENTIFIERS, OPTION_SETS, POP_UP_CODES, SAVE_RESULT_STATUS } from 'src/app/constants/app-data.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { ResponseParserService } from '../../services/response-parser.service';
import { BaseCardSetDetailWithHeaderComponent } from '../base-card-set-detail-with-header-component/base-card-set-detail-with-header-component';
import * as _ from 'lodash';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { getResponseValue } from '../document-list/form.shared';
import { Location } from '@angular/common';

// TODO: Pending requirement finalization. Copied and adapted concession application code for demo
// and prototyping purposes. Actual implementation will be done once requirements are finalized.
@Component({
  selector: 'app-vptas-adjustment-application',
  templateUrl: './vptas-adjustment-application.component.html',
  styleUrls: ['./vptas-adjustment-application.component.scss']
})
export class VptasAdjustmentApplication extends BaseCardSetDetailWithHeaderComponent implements OnInit, OnDestroy {

  fieldTypeReplacements = CardSetTransformationService.cardSetFieldTypeReplacements;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;
  verticalNavigationSettings: VerticalNavigationSettings = { enabled: false, sticky: true, pageLevel: true, type: 'horizontal-stepper' };
  formNavSubscription: Subscription;

  templateId: number = TEMPLATES.vptasAdjustmentApplication;
  versionNo: number = VERSIONS.latest;
  model: any;
  editing: boolean = false;
  // primaryAddressIsManual: boolean = false;
  patientOptions: any[];
  protected id: string = '';
  protected saveEndpoint: string = '';
  protected activeDialog: string = '';
  isDraftApplication: boolean = true;

  parentApplicationId: string = null;
  isCreatingNewApplicationFromParentApplication: boolean = false;

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected dialogService: DialogService,
    protected appDataService: AppDataService,
    protected responseParserService: ResponseParserService,
    protected spinnerService: SpinnerService,
    protected errorService: ErrorService,
    protected dataService: DataService,
    private coreService: CoreService,
    private formNavigationService: FormNavigationService,
    private location: Location
  ) {
    super(router, appDataService, responseParserService);
  }

  ngOnInit(): void {

    this.formServiceEndpoint = API_ENDPOINT_KEYS.getVptasAdjustmentApplicationConfigAndResponse;
    this.saveEndpoint = API_ENDPOINTS.vptasAdjustmentApplication.save;

    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      this.id = paramMap.get('id');
      this.parentApplicationId = paramMap.get('parentApplicationId');
      this.isCreatingNewApplicationFromParentApplication = this.parentApplicationId != null;
    });



    this.coreService.conditionFunctions = {
      isEditing: () => this.editing,
      //exit: () => this.exit(),
      true: () => true,
      false: () => false,
      readOnly: () => true,
      isReadOnly: () => this.isReadOnly(),
    };

    this.coreService.applicationFunctions = {
      openParentApplication: () => this.navigateToParentApplication(),
      openInvoices: () => this.openInvoices(),
      exit: () => this.exit()
    }

    this.coreService.repeatingPageFunctions = {
    };

    this.coreService.repeatingSectionFunctions = {
    };

  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded($event) {
    if (this.baseForm && this.baseForm.model) {
      this.appDataService.setAppData(APP_DATA_KEYS.previousModel, JSON.parse(JSON.stringify(this.baseForm.model)));
    }
    this.formHeaderModel = $event.headerResponse;

    this.coreService.fileUploadFormIdentifiers['evidenceUpload'] = FORM_IDENTIFIERS.vptsFormIdentifier;

    if(!this.parentApplicationId && $event.parentApplicationId){
      this.parentApplicationId = $event.parentApplicationId
    }

    this.forceEnablePageButton('page1-btnOpenParentApplication');
    this.forceEnablePageButton('page1-btnOpenInvoices');

  }

  buttonClick(event: any): void {
  }

  actionButtonClick(event: any): void {
  }

  dialogSubmit(event: any): void {
    
  }

  filter(event: any): void {
  }

  modelChange(event: any): void {
    if (this.baseForm?.model) {
    }
  }

  protected isReadOnly() {
    return false;
  }

  save(event: SaveFormEvent) {
    const saveDataRequest: SaveDataRequest & {
      parentApplicationId: string;
    } = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: event.model,
      isSubmit: event.isSubmit,
      expectedLastUpdateTime: event.lastUpdatedTime,
      parentApplicationId: this.parentApplicationId
    }

    if (event.isSubmit) {
      this.baseForm.markAllFieldsAsTouched();
      if (event.isFormValid === false) {
        this.baseForm.showValidationSummary(true);
      }
      else {
        var amount = getResponseValue(this.baseForm.model.form.tabs, 'tab1', 'page1', -1, 'adjustmentApplication', -1, 'adjustmentAmount');
        var payTo = getResponseValue(this.baseForm.model.form.tabs, 'tab1', 'page1', -1, 'adjustmentApplication', -1, 'payTo');
        var provider = getResponseValue(this.baseForm.model.form.tabs, 'tab1', 'page1', -1, 'adjustmentApplication', -1, 'serviceProvider');
        var note = getResponseValue(this.baseForm.model.form.tabs, 'tab1', 'page1', -1, 'adjustmentApplication', -1, 'note');

        if(Number(amount) == 0){
          this.activeDialog = POP_UP_CODES.vptasAdjustmentApplication.validationErrorAmountZero;
          this.dialogService.showDialog(this.activeDialog);
          return;
        }

        if(payTo == OPTION_SETS.payTo.options.PayToProvider && (provider == null || note == null || note.trim() === '')){
          this.activeDialog = POP_UP_CODES.vptasAdjustmentApplication.validationErrorProviderDetails;
          this.dialogService.showDialog(this.activeDialog);
          return;
        }
        this.saveData(saveDataRequest);
      }
    }
    else {
      this.saveData(saveDataRequest);
    }
  }
    
  cancel(event: any) {
    this.formNavigationService.moveBack();
  }


  saveData(request: SaveDataRequest) {
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.dataService.saveData(this.saveEndpoint, request)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            this.navigateToVptasApplicationsList(true);
          }
        })
    );
  }

  private navigateToVptasApplicationsList(ignoreUnsavedChanges = false): void {
    this.navigate([ROUTE_CONSTANTS.vptasApplication.list.prefix, ROUTE_CONSTANTS.vptasApplication.list.myApplicationsSegment], ignoreUnsavedChanges);
  }

  private navigateToParentApplication(): void {
    const url = this.router.serializeUrl(this.router.createUrlTree(['/', ROUTE_CONSTANTS.vptasApplication.prefix, ROUTE_CONSTANTS.vptasApplication.details.prefix, this.parentApplicationId]));
    window.open(url, '_blank');
  }

  private openInvoices(): void {
    const url = this.router.serializeUrl(this.router.createUrlTree(['/', ROUTE_CONSTANTS.vptasApplication.prefix, this.id, ROUTE_CONSTANTS.vptasApplication.details.invoiceListPrefix]));
    window.open(url, '_blank');
  }

  exit() {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.navigateToVptasApplicationsList();
    }
  }

  private navigateBackToHome(ignoreUnsavedChanges = false): void {
    this.navigate(['/', ROUTE_CONSTANTS.homepage], ignoreUnsavedChanges);
  }

  private forceEnablePageButton(pageId: string) {
    setTimeout(() => {
      const btn = document.getElementById(pageId) as HTMLButtonElement | null;
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('disabled');
      }
    }, 0);
  }
}